import { Results } from '../types'

export const addResult = <T>(item: T) => (data?: Results<T>): Results<T> => {
  if (!data)
    return {
      results: [item],
      count: 1,
      previous: undefined,
      next: undefined,
    }

  return {
    results: [item, ...data.results],
    count: data.count + 1,
    previous: data.previous,
    next: data.next,
  }
}

export const updateResult = <T extends { id: number }>(item: T) => (
  data?: Results<T>
): Results<T> | undefined => {
  if (!data) return undefined

  return {
    ...data,
    results: data.results.map((o) => (o.id === item.id ? item : o)),
  }
}

export const removeResult = <T extends { id: number }>(item: T) => (
  data?: Results<T>
): Results<T> | undefined => {
  if (!data) return undefined

  return {
    results: data.results.filter((y) => y.id !== item.id),
    count: data.count - 1,
    previous: data.previous,
    next: data.next,
  }
}

export const mergeResults = <T>(a: Results<T>) => (
  b?: Results<T>
): Results<T> => ({
  results: [...(b ? b.results : []), ...a.results],
  count: a.count,
  previous: a.previous,
  next: a.next,
})
